import React from 'react'
import * as TwoStepPaymentForm from 'common/components/entities/TwoStepPaymentForm'
import { useStripeGeneralPaymentHandler } from 'publisher/hooks/payment/use-stripe-general-payment-handler'
import useManagement, {
  selectors as managementSelectors,
} from '../../../hooks/useManagement'
import FieldErrors from '../../FieldErrors'
import { TwoStepPaymentButtonProps } from './TwoStepPaymentButtonProps'

export const TwoStepStripeGeneralPaymentButton = ({
  entity,
  styles,
  mobileStyles,
}: TwoStepPaymentButtonProps) => {
  const { errors, isLoading, handleSubmit } =
    useStripeGeneralPaymentHandler(entity)
  const isPreview = useManagement(managementSelectors.isPreviewMode)
  return (
    <React.Fragment>
      <TwoStepPaymentForm.Button
        onClick={handleSubmit}
        styles={styles}
        mobileStyles={mobileStyles}
        text={entity.options.buttonText}
        subText={entity.options.buttonSubText}
        disabled={isLoading || isPreview}
      />
      <FieldErrors errors={errors} />
    </React.Fragment>
  )
}
